import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/ui/components/ui/card.tsx";
import { Skeleton } from "@/ui/components/ui/skeleton.tsx";
import { IPolygonResponse } from "@/polygon/api/requests/polygon.requests.ts";
import { isWithinLastDays } from "@/polygon/utils/date-utils.ts";
import { useTranslation } from "react-i18next";

interface PolygonStatisticsProps {
  polygons: IPolygonResponse[] | undefined;
  isLoading: boolean;
}

export const PolygonStatistics: React.FC<PolygonStatisticsProps> = ({
  polygons,
  isLoading,
}) => {
  const { t } = useTranslation("polygon");
  const totalPolygons = polygons?.length || 0;
  const recentUploads = polygons?.filter(p => 
    isWithinLastDays(p.created_at, 7)
  ).length || 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">{t("statistics.totalPolygons")}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {isLoading ? <Skeleton className="h-8 w-16" /> : totalPolygons}
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">{t("statistics.recentUploads")}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {isLoading ? (
              <Skeleton className="h-8 w-16" />
            ) : (
              recentUploads
            )}
          </div>
          <p className="text-xs text-muted-foreground">{t("statistics.recentUploadsHint")}</p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">{t("statistics.storageUsed")}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {isLoading ? <Skeleton className="h-8 w-16" /> : t("notAvailable")}
          </div>
          <p className="text-xs text-muted-foreground">{t("statistics.storageUsedHint")}</p>
        </CardContent>
      </Card>
    </div>
  );
};
